/* Words in a special font (Theme settings → Typography: per element). */
(() => {
  const el = document.getElementById('font-words');
  if (!el) return;
  const roles = ['display', 'body', 'accent', 'extra', 'digits'];
  const map = new Map();
  el.textContent.split('\n').forEach((l) => {
    const [w, r] = l.split('|').map((s) => (s || '').trim());
    if (w && roles.includes((r || '').toLowerCase())) map.set(w, r.toLowerCase());
  });
  if (!map.size) return;
  const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp('(' + [...map.keys()].sort((a, b) => b.length - a.length).map(esc).join('|') + ')', 'g');
  const skip = /^(SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION|CODE|svg)$/;
  const run = (root) => {
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (!n.parentElement || skip.test(n.parentElement.tagName) || n.parentElement.closest('.fw,[contenteditable]') || !re.test(n.data) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
    });
    const nodes = [];
    while (w.nextNode()) nodes.push(w.currentNode);
    nodes.forEach((n) => {
      re.lastIndex = 0;
      const frag = document.createDocumentFragment();
      n.data.split(re).forEach((part) => {
        if (map.has(part)) {
          const s = document.createElement('span');
          s.className = 'fw fw--' + map.get(part);
          s.textContent = part;
          frag.appendChild(s);
        } else if (part) frag.appendChild(document.createTextNode(part));
      });
      n.replaceWith(frag);
    });
  };
  run(document.body);
  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => run(document.body), 200); })
    .observe(document.body, { childList: true, subtree: true });
})();
